import React from 'react'
import { Navigate, useLocation } from 'react-router'

/** Legacy `/watchlist` → `/account/watchlist` (preserves query string). */
const WatchlistRedirect: React.FC = () => {
  const location = useLocation()
  return <Navigate to={`/account/watchlist${location.search}`} replace />
}

export default WatchlistRedirect
